import { render, staticRenderFns } from "./UsersParent.vue?vue&type=template&id=7287b2cc&"
import script from "./UsersParent.vue?vue&type=script&lang=js&"
export * from "./UsersParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports